import { useState } from "react";

export function useOpenHamburgerMenu(controlledActive?: boolean) {
  const [internalActive, setInternalActive] = useState(false);

  const isActive = controlledActive !== undefined ? controlledActive : internalActive;

  const handleClick = () => {
    if (controlledActive === undefined) {
      setInternalActive((prev) => !prev);
    }
  };

  return { isActive, handleClick };
}
